import { prepareRuntime } from './appMount';

async function boot() {
  await prepareRuntime('boot');
  await import('./bootloader');
}

boot().catch((error) => console.error('[downloads-ui] boot failed', error));
